import React, { useState, useEffect } from "react";
import withRouter from "../../HOC/withRouter";
import { connect } from "react-redux";
import { compose } from "react-recompose";
import { insertTags } from "../../utils/url";
import tpFulfilledIndicator from "../../static/images/tpFulfilledIndicator.svg";
import tpNotFulfilledIndicator from "../../static/images/tpNotFulfilledIndicator.svg";
import ArrowUpIcon from "../../static/images/ArrowUpIcon.svg";
import ArrowDownIcon from "../../static/images/ArrowDownIcon.svg";
import EditMilestoneIcon from "../../components/svgs/EditMilestoneIcon";

const AuditResultsList = ({ t, client, navigate, markegGoalAudits, profileId, setExpandState }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.get("isPDF") === "true") {
      setIsVisible(true);
    }
  }, []);

  const editAudit = (touchPointId, auditId) => {
    navigate({
      pathname: `/audit/${touchPointId}/${auditId}`,
      replace: true,
    });
  };

  if (!isVisible) {
    return (
      <div className="form-value">
        <div
          className="open-audits-icon"
          onClick={() => {
            setIsVisible(true);
            setExpandState(true);
          }}
        >
          <span>{t("touchpoint.BrandCheck")}</span>
          <img src={ArrowDownIcon} alt="" />
        </div>
      </div>
    );
  }
  return (
    <div className="audits-list">
      {markegGoalAudits.map((item, index) => {
        return (
          <div key={index} className="form-value">
            <div className="form-audit-result">
              <div className="form-marketGoal-text-block audit">
                <div className="form-marketGoal-text audit">
                  {item.auditId.name}
                  {item.auditId.auditor === profileId && (
                    <div className="edit-audit" onClick={() => editAudit(item.touchPointId, item.auditId._id)}>
                      <EditMilestoneIcon color={client?.altColor} />
                    </div>
                  )}
                </div>
                {item.description && (
                  <div className="form-marketGoal-description">
                    <pre
                      className="display-comment-textarea audit"
                      dangerouslySetInnerHTML={{ __html: insertTags(item.description) }}
                    ></pre>
                  </div>
                )}
              </div>
              <div className="audit-check-container">
                <div className="form-marketGoal-check audit">
                  {item.status ? (
                    <img src={tpFulfilledIndicator} alt="" />
                  ) : (
                    <img src={tpNotFulfilledIndicator} alt="" />
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
      <div
        className="close-audits-icon"
        onClick={() => {
          setIsVisible(false);
          setExpandState(false);
        }}
      >
        <img src={ArrowUpIcon} alt="" />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  client: state.client.client,
});

export default compose(withRouter, connect(mapStateToProps, null))(AuditResultsList);
